import { useState, useEffect } from 'react';
import { bookingRepository } from '../../../domain/bookingRepository';


// Not cached in the store (unlike useBookingData): each booking is only
// looked at on its own detail screen, so it's always fetched fresh.
export const useBookingDetail = (bookingId) => {

    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let isCancelled = false; // Ignore a stale response if bookingId changes mid-request
        setIsLoading(true);
        setError(null);
        bookingRepository.getBookingDetail(bookingId)
            .then((detail) => {
                if (isCancelled) return;
                setData(detail);
                setIsLoading(false);
            })
            .catch((err) => {
                if (isCancelled) return;
                console.error("Failed to fetch booking detail:", err);
                setError(err);
                setIsLoading(false);
            });
        return () => { isCancelled = true; };
    }, [bookingId]);

    // setData lets the screen show edited fields once they're saved, without refetching.
    return { data, isLoading, error, setData };
};
